import type {Module} from "vuex";
import type {RootState} from "@/store/types";

export interface ConfigPageHomeState {
    maxItems: number
}

const home: Module<ConfigPageHomeState, RootState> = {
    namespaced: true,
    state: {
        maxItems: 10
    },
    getters: {
        maxItems: (state): number => state.maxItems
    },
    mutations: {
        setMaxItems: (state, maxItems: number) => state.maxItems = maxItems
    },
    actions: {
        setMaxItems(context, maxItems: number) {

            context.commit("setMaxItems", maxItems);
        },
        clear(context) {

            context.commit("setMaxItems", 10);
        }
    }
}

export default home
